import api from './api';

const withStore = (storeId, config = {}) => ({ ...config, _storeId: storeId });

const MoloniService = {
  getConnection: async (storeId, edit = false) => {
    const response = await api.get('/moloni/connection', withStore(storeId, { params: edit ? { edit: true } : {} }));
    return response.data;
  },

  disconnect: async (storeId) => {
    await api.delete('/moloni/connection', withStore(storeId));
  },

  connect: async (storeId) => {
    const response = await api.post('/moloni/connect', null, withStore(storeId));
    return response.data?.url || response.data?.Url;
  },

  getDocumentSets: async (storeId, companyId) => {
    const response = await api.get('/moloni/connection/document-sets', withStore(storeId, { params: { companyId } }));
    return response.data || [];
  },

  selectCompany: async (storeId, companyId, documentSetId) => {
    await api.put('/moloni/connection', { companyId, documentSetId }, withStore(storeId));
  },

  preview: async (storeId, sourceKey) => {
    const response = await api.get('/moloni/documents/preview', withStore(storeId, { params: { sourceKey } }));
    return response.data;
  },

  flags: async (storeId, sourceKeys) => {
    const response = await api.get('/moloni/documents', withStore(storeId, {
      params: { sourceKeys },
      paramsSerializer: { indexes: null },
    }));
    return response.data || [];
  },

  issue: async (storeId, sourceKey, customer) => {
    const response = await api.post('/moloni/documents', { sourceKey, customer }, withStore(storeId));
    return response.data;
  },

  bulk: async (storeId, body) => {
    const response = await api.post('/moloni/documents/bulk', body, withStore(storeId));
    return response.data;
  },

  job: async (storeId, jobId) => {
    const response = await api.get(`/moloni/documents/jobs/${jobId}`, withStore(storeId));
    return response.data;
  },

  resend: async (storeId, sourceKey) => {
    await api.post('/moloni/documents/resend', { sourceKey }, withStore(storeId));
  },

  link: async (storeId, sourceKey) => {
    const response = await api.get('/moloni/documents/link', withStore(storeId, { params: { sourceKey } }));
    return response.data?.url || response.data?.Url;
  },
};

export default MoloniService;
